import ReactHtmlParser from 'react-html-parser';

export function HrefLangLinks({ links }: { links: string }) {
  return <>{ReactHtmlParser(links.replaceAll('<br/>', ''))}</>;
}
